// Constants.
import * as StatsChartsConstants from 'constants/StatsChartsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetched: false,
  isFetching: false,
  chartsCategories: {},
};

export default function chartsCategories(state = initialState, action = {}) {
  switch (action.type) {
    case StatsChartsConstants.LOAD_CHARTS_CATEGORIES_REQUEST:
      return {
        ...state,
        isFetched: initialState.isFetched,
        isFetching: true,
        chartsCategories: initialState.chartsCategories,
      };
    case StatsChartsConstants.LOAD_CHARTS_CATEGORIES_SUCCESS: {
      const locale = action.locale;
      const chartsCategoriesItems = [ ...action.chartsCategories ];
      const chartsCategories = [];
      chartsCategoriesItems.map((chartsCategoriesItem) => {
        if (chartsCategoriesItem.title !== undefined) {
          chartsCategoriesItem.title = chartsCategoriesItem.title[locale];

        }
        chartsCategories.push(chartsCategoriesItem);
      });

      return {
        ...state,
        isFetched: true,
        isFetching: false,
        chartsCategories: chartsCategories,
      };
    }
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGIN_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        chartsFlow: initialState.chartsFlow,
      };
    default:
      return state;
  }
}
